import { configureStore } from '@reduxjs/toolkit';
import taskReducer from '../features/daoTrang/daoTrangSlice'
import userReducer from '../features/user/userSlice'
import authReducer from '../features/auth/authSlice'
import btcReducer from '../features/btc/btcSlice'
import notificationReducer from '../features/notification/notificationSlice'
import undoable from "redux-undo";

export const store = configureStore({
  reducer: {
  auth: authReducer,
  task: undoable(taskReducer, {
    filter: function filterActions(action, currentState, previousHistory) {
      return action.type.match("task/");
    },
  }),
  user:userReducer,
  notif: notificationReducer,
  btc: btcReducer,
  },
});